interface PageHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

/**
 * Page sub-header. The visible page title lives in the top bar, so the title
 * here is rendered as a screen-reader-only <h1> (keeps one accessible heading
 * per page without the visible duplication). Description + actions render inline.
 */
export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <div
      className={description || action ? "mb-6 flex items-start justify-between gap-4" : undefined}
    >
      <div>
        <h1 className="sr-only">{title}</h1>
        {description && <p className="text-pulso-muted">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
